import { render } from "./AddNotification.vue?vue&type=template&id=5d83a46e&scoped=true&ts=true"
import script from "./AddNotification.vue?vue&type=script&lang=ts"
export * from "./AddNotification.vue?vue&type=script&lang=ts"

import "./AddNotification.vue?vue&type=style&index=0&id=5d83a46e&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d83a46e"]])

export default __exports__